import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getAllMaterialTypeTree } from '@/pages/baseData/category/api'
import { setLocalStorage } from '@/utils/tools'

const materialTypeTreeCacheKey = 'cache-material-type-tree'

export const fetchGetMaterialTypeTreeAsync = createAsyncThunk(
  'materialType/fetchGetMaterialTypeTreeAsync',
  () =>
    axios
      .get(`/app/material-category/product-category`)
      .then((response) => {
        const resp = response?.data
        if (resp === null) return []
        setLocalStorage(materialTypeTreeCacheKey, resp)
        return resp ?? []
      })
      .catch((err) => {
        throw Error('读取产品类型数据缓存失败')
      })
)
export const fetchGetMaterialTypeTreeAllAsync = createAsyncThunk(
  'materialType/fetchGetMaterialTypeTreeAllAsync',
  () =>
    axios
      .get(getAllMaterialTypeTree())
      .then((response) => {
        const resp = response?.data
        if (resp === null) return []
        setLocalStorage('cache-material-type-tree-all', resp)
        return resp ?? []
      })
      .catch((err) => {
        throw Error('读取产品类型数据缓存失败')
      })
)

const materialTypeSlice = createSlice({
  name: 'materialType',
  initialState: {
    materialTypeTree: [],
    materialTypeTreeAll: [],
  },
  reducers: {
    setMaterialTypeTree(state, action) {
      state.materialTypeTree = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetMaterialTypeTreeAsync.pending, (state) => {
        state.materialTypeTree = []
      })
      .addCase(fetchGetMaterialTypeTreeAsync.fulfilled, (state, action) => {
        state.materialTypeTree = action.payload
      })
      .addCase(fetchGetMaterialTypeTreeAllAsync.pending, (state) => {
        state.materialTypeTreeAll = []
      })
      .addCase(fetchGetMaterialTypeTreeAllAsync.fulfilled, (state, action) => {
        state.materialTypeTreeAll = action.payload
      })
  },
})

export const { setMaterialTypeTree } = materialTypeSlice.actions
export const getMaterialTypeTree = (state) =>
  state.materialType.materialTypeTree
export const getMaterialTypeTreeAll = (state) =>
  state.materialType.materialTypeTreeAll
export default materialTypeSlice.reducer
